module.exports = __webpack_public_path__ + "img/horizontal_6_6_3016.aa195d6c.png";